export interface IProviderSpecialization {
  providerSpecializationId :number;
  providerId :number;
  specializationId :number;
  specializationName :string;
  active:boolean;
  createdBy:number;
  createdDate :Date;
}